<template>
	<div class="login">
		<LoginHead>欢迎注册！</LoginHead>
		<RegFrame>
			<div class="reg_d2_pad">
				<div class="regd2pad_d1">
					<span class="regd2pad_d1_sp1">新用户注册</span>
					<div class="regd2pad_d1_d2">
						<span>已有账号？</span>
						<a @click="toLogin()">立即登录</a>
					</div>
				</div>
			</div>
			<el-form
				:model="ruleForm"
				status-icon
				:rules="rules"
				ref="ruleForm"
				label-width="100px"
				class="demo-ruleForm"
			>
				<el-form-item label="用 户 名：" class="login_d2_d2_el1" prop="inp1">
					<el-input placeholder="请输入用户名" v-model="ruleForm.inp1"></el-input>
				</el-form-item>
				<el-form-item label="会员密码：" class="login_d2_d2_el1" prop="inp2">
					<el-input placeholder="请输入会员密码" type="password" v-model="ruleForm.inp2"></el-input>
				</el-form-item>
				<el-form-item label="确认密码：" class="login_d2_d2_el1" prop="inp3">
					<el-input placeholder="请再次输入会员密码" type="password" v-model="ruleForm.inp3"></el-input>
				</el-form-item>
				<el-form-item label="手机号码：" class="login_d2_d2_el1" prop="inp4">
					<el-input placeholder="请输入手机号码" v-model="ruleForm.inp4"></el-input>
				</el-form-item>
				<el-form-item prop="type">
					<el-checkbox-group v-model="ruleForm.type">
						<el-checkbox label="我同意《江南药镇商城用户协议》" name="type"></el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item>
					<el-button class="login_d2_d2_el1_but" type="success" @click="submitForm('ruleForm')">立即注册</el-button>
				</el-form-item>
			</el-form>
		</RegFrame>
		<div :style="{ height: '100px' }"></div>
		<Foot />
	</div>
</template>

<style>
.login .el-form-item__content {
	line-height: 16px !important;
}
</style>

<script>
import { mapGetters } from "vuex"
import Foot from "@/components/Foot"
import LoginHead from "@/components/LoginHead"
import RegFrame from "@/components/RegFrame"
export default {
	components: {
		LoginHead,
		Foot,
		RegFrame
	},
	computed: {
		...mapGetters(["device"])
	},
	data() {
		var inp1Pass = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('用户名不能为空'));
			} else {
				callback();
			}
		};
		var inp2Pass = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('会员密码不能为空'));
			} else if (value.length < 6) {
				return callback(new Error('密码长度太短'));
			} else {
				callback();
			}
		};
		var inp3Pass = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('确认密码不能为空'));
			} else if (value != this.ruleForm.inp2) {
				return callback(new Error('两次输入的密码不一致'));
			} else {
				callback();
			}
		};
		var inp4Pass = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('手机号不能为空'));
			} else if (!(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value))) {
				return callback(new Error('手机号格式有误'));
			} else {
				callback();
			}
		};
		var inp5Pass = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('验证码不能为空'));
			} else {
				callback();
			}
		};
		var typePass = (rule, value, callback) => {
			if (value.length > 0) {
				callback();
			} else {
				return callback(new Error('请同意用户协议'));
			}
		};
		return {
			isSend: false,
			codetips: "发送验证码",

			ruleForm: {
				inp1: '',
				inp2: '',
				inp3: '',
				inp4: '',
				inp5: '',
				type: ["我同意《江南药镇商城用户协议》"]
			},
			rules: {
				inp1: [{
					validator: inp1Pass,
					trigger: 'blur'
				}],
				inp2: [{
					validator: inp2Pass,
					trigger: 'blur'
				}],
				inp3: [{
					validator: inp3Pass,
					trigger: 'blur'
				}],
				inp4: [{
					validator: inp4Pass,
					trigger: 'blur'
				}],
				// inp5: [{
				// 	validator: inp5Pass,
				// 	trigger: 'blur'
				// }],
				type: [{
					validator: typePass,
					type: 'array',
					required: true,
					message: '请同意用户协议',
					trigger: 'change'
				}]
			}
		}
	},
	watch: {

	},
	created: function () {

	},
	mounted: function () {

	},
	methods: {
		toLogin() {
			this.$router.push("/login")
		},
		sendCode() {
			var that = this
			that.isSend = true
			var num = 60
			that.codetips = num + "s后重新发送"
			var time = setInterval(function () {
				num--
				if (num > 0) {
					that.codetips = num + "s后重新发送"
				} else {
					that.codetips = "重新发送"
					that.isSend = false
					clearInterval(time)
				}
			}, 1000)
		},
		submitForm(formName) {
			var that = this;
			that.$refs[formName].validate(async (valid) => {
				if (valid) {
					let res = await this.$post('Register', {
						"RealName": that.ruleForm.inp1,
						"pwd": that.ruleForm.inp2,
						"Mobile": that.ruleForm.inp4
					})
					if (res.data.Success == "true") {
						that.$message({
							message: '恭喜你，注册成功，马上登录吧！',
							type: 'success'
						});
						that.$router.push("/login")
					} else {
						that.$message.error(res.data.Msg);
					}

				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
	}
}
</script>

<style scoped lang="scss" >
.reg_d2_pad {
	width: 80%;
	margin: 0 auto;
}

.regd2pad_d1 {
	width: 100%;
	height: 60px;
	box-sizing: border-box;
	border-bottom: 1px solid #cccccc;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-end;
}

.regd2pad_d1_sp1 {
	height: 60px;
	line-height: 60px;
	box-sizing: border-box;
	border-bottom: 2px solid #0aac58;
	margin-left: 10px;
	color: #0aac58;
	font-size: 24px;
	position: relative;
	top: 1px;
}

.regd2pad_d1_d2 {
	height: 40px;
	line-height: 40px;
	font-size: 14px;
}

.regd2pad_d1_d2 a {
	color: #409eff;
}

.login_d2_d2_el1 {
	width: 90%;
}

.demo-ruleForm {
	margin-top: 50px;
}
</style>

<style lang="scss" scoped src="./desktop.scss" ></style>